<template>
  <div v-show="pda.status && !exec[313]" class="pda-scan-button" @touchstart="start" @touchmove="move" @touchend="end" :style="{left: `${btnPos.x}px`, top: `${btnPos.y}px`}">
    <el-button ref="btn" type="warning" size="small" round @click="openScan">
      扫码
    </el-button>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'ScanButton',
  computed: {
    ...mapGetters(['pda', 'exec'])
  },
  props: {
    continuous: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      active: false,
      scanner: null,
      btnPos: {
        x: 0,
        y: 0
      },
      touch: {
        offsetX: 0,
        offsetY: 0
      }
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      // 初始化按钮的位置（距离右侧20px, 距离底部40px）
      const { clientWidth: screenWidth, clientHeight: screenHeight } = window.document.documentElement
      const screen = {
        height: screenHeight,
        width: screenWidth,
      }
      const btn = this.$refs.btn.$el
      const { width: btnWidth, height: btnHeight } = window.getComputedStyle(btn)
      const left = screen.width - 20 - parseInt(btnWidth)
      const top = screen.height - 40 - parseInt(btnHeight)
      this.btnPos.x = left
      this.btnPos.y = top
    },
    openScan() {
      // 打开扫码
      this.scanner = this.$scanner(this.continuous)
      this.scanner.then(code => {
        if (code) {
          this.$emit('scaned', code)
          this.scanner = null
          if (this.continuous) {
            this.openScan()
          }
        }
      })
    },
    start(ev) {
      // 开始拖动
      let touch = null
      if (ev.touches) {
        touch = ev.touches[0]
      } else {
        touch = ev
      }
      this.touch.offsetX = touch.clientX - this.btnPos.x
      this.touch.offsetY = touch.clientY - this.btnPos.y
      this.active = true
    },
    move(ev) {
      // 拖动中
      ev.stopPropagation()
      ev.preventDefault()
      if (this.active) {
        let touch = null
        if (ev.touches) {
          touch = ev.touches[0]
        } else {
          touch = ev
        }

        this.btnPos.x = touch.clientX - this.touch.offsetX
        this.btnPos.y = touch.clientY - this.touch.offsetY
      }
    },
    end() {
      // 结束拖动
      this.active = false
      this.touch = {
        offsetX: 0,
        offsetY: 0
      }
    },
  }
}
</script>
